module.exports = __webpack_public_path__ + "static/img/1.5827a96.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/countdown/1.png
// module id = 485
// module chunks = 1